<template>
  <div @touchstart="touchIsStarted($event)" class="drag-and-drop">
    <h2 class="drag-and-drop__heading" :key="$i18n.locale">
      {{ t(content.heading) }}
    </h2>
    <!-- <app-image
      svg="<svg id='Ebene_1' data-name='Ebene 1' xmlns='http://www.w3.org/2000/svg' width='327.25488' height='216' viewBox='0 0 327.25488 216'> <g> <line x1='320.3569' y1='80.5' x2='104.64309' y2='80.5' fill='none' stroke='#009fe3' stroke-linecap='round' stroke-linejoin='round' stroke-width='2'/> <path d='M320.24411,78.24414c1.24573,0,2.25589,1.01016,2.25589,2.25586s-1.01016,2.25586-2.25589,2.25586-2.25583-1.01016-2.25583-2.25586,1.01016-2.25586,2.25583-2.25586Z' fill='#009fe3'/> <path d='M104.75588,78.24414c-1.24572,0-2.25588,1.01016-2.25588,2.25586s1.01016,2.25586,2.25588,2.25586,2.25584-1.01016,2.25584-2.25586-1.01016-2.25586-2.25584-2.25586Z' fill='#009fe3'/> </g> <line x1='102.5' y1='200.5' x2='102.5' y2='215.5' fill='#fff' stroke='#fff' stroke-linecap='round' stroke-linejoin='round'/> <path d='M175,200.5v15' fill='#fff' stroke='#fff' stroke-linecap='round' stroke-linejoin='round'/> <path d='M102.5,208h72.5' fill='#fff' stroke='#fff' stroke-linecap='round' stroke-linejoin='round'/> <g> <line x1='322.5' y1='86.53516' x2='322.5' y2='180.5' fill='none' stroke='#e6332a' stroke-linecap='round' stroke-linejoin='round'/> <path d='M322.5,80.5c-1.05371,2.8398-2.85156,6.36328-4.75586,8.54736l4.75586-1.72021,4.75488,1.72021c-1.9043-2.18408-3.70215-5.70757-4.75488-8.54736Z' fill='#e6332a'/> </g> <g> <line x1='117.5' y1='.5' x2='175' y2='80.5' fill='#fff'/> <g> <line x1='117.5' y1='.5' x2='171.47766' y2='75.59935' fill='none' stroke='#e6332a' stroke-linecap='round' stroke-linejoin='round'/> <path d='M175,80.5c-2.51303-1.69098-6.02934-3.50281-8.85037-4.1649l4.8658-1.37885,2.85706-4.17197c-.27161,2.88492,.32494,6.79533,1.12752,9.71571Z' fill='#e6332a'/> </g> </g> <g> <line x1='102.5' y1='180.5' x2='102.5' y2='86.53516' fill='none' stroke='#e6332a' stroke-linecap='round' stroke-linejoin='round'/> <path d='M102.5,80.5c1.05371,2.8398,2.85156,6.36328,4.75586,8.54736l-4.75586-1.72021-4.75488,1.72021c1.90429-2.18408,3.70216-5.70757,4.75488-8.54736Z' fill='#e6332a'/> </g> <g> <path d='M102.5,80.5c-34.16667-.1583-68.33333-.3166-102.5-.4749' fill='#fff'/> <g> <path d='M102.5,80.5c-32.15497-.14899-64.30994-.29796-96.4649-.44695' fill='none' stroke='#e6332a' stroke-linecap='round' stroke-linejoin='round'/> <path d='M0,80.0251c2.84465-1.04054,6.37642-2.82205,8.5693-4.71622l-1.74223,4.74785,1.69816,4.7628C6.35,82.90514,2.83489,81.09097,0,80.0251Z' fill='#e6332a'/> </g> </g> <g> <path d='M120,78c18.33334,0,31.66666,0,50,0' fill='#fff'/> <g> <path d='M120,78h43.96455' fill='none' stroke='#e6332a' stroke-dasharray='0 0 3 3' stroke-linecap='round' stroke-linejoin='round'/> <path d='M170,78c-2.8398,1.05371-6.36328,2.85156-8.54736,4.75586l1.72021-4.75586-1.72021-4.75488c2.18408,1.9043,5.70757,3.70215,8.54736,4.75488Z' fill='#e6332a'/> </g> </g> <g> <path d='M175,.5V69.46484' fill='none' stroke='#e6332a' stroke-dasharray='0 0 3 3' stroke-linecap='round' stroke-linejoin='round'/> <path d='M175,75.5c-1.05371-2.8398-2.85156-6.36328-4.75586-8.54736l4.75586,1.72021,4.75488-1.72021c-1.9043,2.18408-3.70215,5.70757-4.75488,8.54736Z' fill='#e6332a'/> </g> <g> <path d='M117.5,100.5c0,13.72396,0,28.77604,0,42.5' fill='#fff'/> <g> <path d='M117.5,100.5v36.46616' fill='none' stroke='#3aaa35' stroke-linecap='round' stroke-linejoin='round'/> <path d='M117.5,143c-1.05371-2.8398-2.85156-6.36328-4.75586-8.54736l4.75586,1.72021,4.75488-1.72021c-1.9043,2.18408-3.70215,5.70757-4.75488,8.54736Z' fill='#3aaa35'/> </g> </g> <g> <path d='M117.5,100.5h33.96484' fill='none' stroke='#3aaa35' stroke-linecap='round' stroke-linejoin='round'/> <path d='M157.5,100.5c-2.8398,1.05371-6.36328,2.85156-8.54736,4.75586l1.72021-4.75586-1.72021-4.75488c2.18408,1.9043,5.70757,3.70215,8.54736,4.75488Z' fill='#3aaa35'/> </g> <g> <path d='M138.5,138.78947c2.79199-1.18784,7.29503-3.4915,11.39999-7.65929,2.53084-2.56955,4.25577-5.18304,5.43764-7.49675' fill='none' stroke='#3aaa35' stroke-linecap='round' stroke-linejoin='round'/> <path d='M157.5,118c-.0687,3.02821,.30193,6.96646,1.26576,9.69914l-3.78531-3.35391-5.05406-.15599c2.57588-1.32715,5.54716-3.9384,7.57361-6.18924Z' fill='#3aaa35'/> </g> <path d='M144.97267,76.99284c-.1442-.30136-3.49352-6.65135,.02733-13.99284,2.2409-4.67263,6.29203-7.54047,10.78025-7.49762' fill='none' stroke='#fff' stroke-linecap='round' stroke-linejoin='round'/> </svg>"
      :imageData="{
        position: [-5.5, -6],
        width: 360,
        height: 220
      }"
      :imageText="[
        { text: '$F$', position: [98, 0], fontSize: 16, color: '#e6332a' },
        { text: '$\\alpha$', position: [149, 60], fontSize: 16 },
        { text: '$A$', position: [98, 60], fontSize: 16, color: '#009fe3' },
        { text: '$B$', position: [316, 60], fontSize: 16, color: '#009fe3' },
        { text: '$A_x$', position: [10, 60], fontSize: 16, color: '#e6332a' },
        { text: '$A_z$', position: [75, 164], fontSize: 16, color: '#e6332a' },
        { text: '$B_z$', position: [295, 100], fontSize: 16, color: '#e6332a' },
        { text: '$x$', position: [155, 101], fontSize: 16, color: '#3aaa35' },
        { text: '$z$', position: [124, 131], fontSize: 16, color: '#3aaa35' },
        { text: '$l/3$', position: [129, 213], fontSize: 16 }
      ]"
      class="drag-and-drop__image"
    ></app-image> -->
    <p
      class="drag-and-drop__instructions"
      :key="$i18n.locale"
      v-html="t(content.instructions)"
    ></p>
    <div
      v-for="(i, index) in numberOfLines"
      :key="i"
      class="drag-and-drop__drop-area"
      :class="{ 'drag-and-drop__drop-area--active': droppableIsActive }"
    >
      <div
        :ref="'droppable__' + index"
        class="drag-and-drop__droppable"
        :class="[
          { 'drag-and-drop__droppable--active': droppableIsActive },
          'drag-and-drop__droppable--' + index
        ]"
      ></div>
    </div>
    <!-- <div
      class="drag-and-drop__drop-area"
      :class="{ 'drag-and-drop__drop-area--active': droppableIsActive }"
    >
      <div
        ref="droppable__0"
        class="drag-and-drop__droppable"
        :class="[
          { 'drag-and-drop__droppable--active': droppableIsActive },
          'drag-and-drop__droppable--' + 0
        ]"
      ></div>
    </div>
    <div
      class="drag-and-drop__drop-area"
      :class="{ 'drag-and-drop__drop-area--active': droppableIsActive }"
    >
      <div
        ref="droppable__1"
        class="drag-and-drop__droppable"
        :class="[
          { 'drag-and-drop__droppable--active': droppableIsActive },
          'drag-and-drop__droppable--' + 1
        ]"
      ></div>
    </div> -->
    <app-course-button
      class="drag-and-drop__evaluate-button"
      :class="{
        'drag-and-drop__evaluate-button--no-transition': transitionIsSuspended,
        'drag-and-drop__evaluate-button--is-active':
          evaluateButtonIsShown && answersInDropElement.length > 0,
        'drag-and-drop__evaluate-button--is-greyed-out': !evaluateButtonIsActive
      }"
      :text="$t('course_order').evaluate_button"
      @click="evaluateAnswer()"
      @touchstart="evaluateAnswer()"
      variation="secondary"
      :active="evaluateButtonIsShown && answersInDropElement.length > 0"
      :hidden="exerciseFinished >= 1 ? true : false"
    />
    <div class="drag-and-drop__drag-area">
      <div>
        <div
          v-for="(answer, index) in allAnswers"
          :key="answer + 'keyForDragElements' + index"
          @mousedown="startDrag($event, index)"
          @touchstart="startDrag($event, index)"
          :ref="'draggable_' + index"
          class="drag-and-drop__draggable"
          :class="{
            'drag-and-drop__reset': elementsAreReset,
            'drag-and-drop__suspend-transition': transitionIsSuspended,
            'drag-and-drop__is-grabbed':
              elementIsGrabbed && index === recentElementDragged,
            'drag-and-drop__is-on-top':
              elementIsOnTop && index === recentElementDragged,
            'drag-and-drop__is-dropped':
              answersInDropElement.indexOf(index) > -1,
            'drag-and-drop__is-dropped-finished':
              answersInDropElement.indexOf(index) > -1 && exerciseFinished >= 1,
            'drag-and-drop__correct':
              answerIsCorrect && answersInDropElement.indexOf(index) > -1,
            'drag-and-drop__wrong':
              answerIsWrong && answersInDropElement.indexOf(index) > -1,
            'drag-and-drop__inactive':
              exerciseFinished >= 1 &&
              answersInDropElement.indexOf(index) === -1,
            'drag-and-drop__capitalized':
              completeSentence &&
              completeSentence[0] &&
              exerciseFinished >= 1 &&
              answersInDropElement.indexOf(index) === 0
          }"
        >
          <div>
            {{ t(answer) }}
            <span
              v-if="
                completeSentence &&
                  exerciseFinished >= 1 &&
                  answersInDropElement[answersInDropElement.length - 1] ===
                    index
              "
              class="drag-and-drop__period"
              :class="{
                'drag-and-drop__period--visible':
                  completeSentence[1] && exerciseFinished >= 1
              }"
              >{{ completeSentence[1] }}
            </span>
          </div>
        </div>
      </div>
    </div>
    <app-message
      :data="messageData"
      :isShown="messageIsShown"
      :transitionIsSuspended="transitionIsSuspended"
      @messageClosed="messageIsShown = false"
      class="drag-and-drop__message"
      :class="{
        'drag-and-drop__message--is-shown': messageIsShown,
        'drag-and-drop__message--evaluate-button-not-active': !evaluateButtonIsActive
      }"
    ></app-message>
    <div v-for="(answer, index) in permittedAnswers" :key="answer">
      <audio v-if="answer.audio" :id="'sound-effect-' + index">
        <source
          :src="
            // 'http://mathopia3.s3-website.eu-central-1.amazonaws.com/' +
            'https://mathopia.com/audio/' + answer.audio + '.mp3'
          "
          type="audio/mpeg"
          preload="auto"
        />
      </audio>
    </div>
    <app-button
      @click="setPage('++')"
      @touchstart="setPage('++')"
      :text="$t('course_continue_button')"
      class="drag-and-drop__continue-button"
      :class="{
        'drag-and-drop__continue-button--shown': exerciseFinished === 2
      }"
    ></app-button>
  </div>
</template>

<script>
import AppButton from "@/components/Atoms/Button.vue";
import AppCourseButton from "@/components/Atoms/CourseButton.vue";
// import AppImage from "@/components/Organisms/Image.vue";
import AppMessage from "@/components/Molecules/Message.vue";

export default {
  components: {
    AppButton,
    AppCourseButton,
    // AppImage,
    AppMessage
  },
  props: {
    content: Object,
    isShown: {
      type: Boolean,
      default: false
    },
    exerciseIsReset: {
      type: Boolean,
      default: false
    },
    section: Number,
    page: Number
  },
  data() {
    return {
      // testvar: 0,
      answers: [],
      // info: "",
      additionalAnswers: [],
      permittedAnswers: [],
      infoGeneral: "",
      infoReversed: "",
      orderOfAnswers: [],
      allowReversedOrder: false,
      playAnswerAudioOnly: false,
      preventIdenticalOrder: true,
      autoEvaluate: false,
      completeSentence: false,
      orderElementsHorizontally: true,
      putElementsInBetween: true,
      feedbackGeneral: "",
      feedbackFailedTries: [],
      feedbackReversedOrder: "",
      feedbackElementLacking: "",
      feedbackAdditionalWasUsed: "",
      feedbackAdaptedToAnswer: [],

      reRandomizeQuestions: false, // Handles randomization after refresh

      allAnswers: [],
      correctAnswers: [],
      correctPermittedAnswers: [],
      wrongAdaptedAnswers: [],
      numberOfLines: 1,
      recentElementDragged: 0,
      elementsAreReset: false,
      transitionIsSuspended: false,
      elementIsGrabbed: false,
      elementIsOnTop: false,
      xPositionDragStart: 0,
      yPositionDragStart: 0,
      topOfDraggedElement: 0,
      heightOfDraggedElement: 0,
      draggableElements: [],
      droppableElements: [],
      droppableIsActive: false,
      audioHasNotPlayed: true,
      recentLine: -1,
      answersInDropElement: [],
      answersInDropLines: [[], []],
      leftOfDroppedElements: [],
      topOfDroppedElements: [],
      answerIsCorrect: false,
      answerIsWrong: false,
      exerciseFinished: false,
      numberOfFailedTries: 0,
      sortAdditionalElementsTimerX: 667,
      sortAdditionalElementsTimerY: 1067,
      savedOrderOfAnswers: [],
      evaluateButtonIsActive: false,

      message: "",
      type: "message",
      image: "",
      messageData: {},
      messageIsShown: false
    };
  },
  computed: {
    offsetY() {
      return window.pageYOffset;
    },
    coursePage() {
      return this.$store.state.coursePage;
    },
    evaluateButtonIsShown() {
      return (
        this.answersInDropElement.length === this.answers.length ||
        (this.allAnswers.length > this.answers.length &&
          this.answersInDropElement.length > 0)
      );
    },
    language() {
      return this.$i18n.locale;
    },
    widthFirst() {
      let widthOfElementsInFirstField = 0;
      for (let i = 0; i < this.answersInDropElement1.length; i++) {
        widthOfElementsInFirstField +=
          this.draggableElements[this.answersInDropElement1[i]][2] +
          this.remToPx(1.5);
      }

      return widthOfElementsInFirstField - this.remToPx(1.5);
    }
  },
  methods: {
    touchIsStarted(e) {
      e.preventDefault();
    },
    startDrag(e, index) {
      // e.preventDefault();

      if (this.exerciseFinished) return;
      this.evaluateButtonIsActive = true;

      this.messageIsShown = false;

      if (this.audioHasNotPlayed) {
        this.audioHasNotPlayed = false;
      }
      this.removeSelection();
      this.recentElementDragged = index;
      let draggableElement = this.$refs["draggable_" + index];
      let leftDraggableElement = this.left(draggableElement);
      let topDraggableElement = this.top(draggableElement);

      this.topOfDraggedElement = topDraggableElement;
      this.heightOfDraggedElement = this.height(draggableElement);

      let coordinate = this.getCursorPosition(e);
      let xCoordinateMouse = coordinate[0];
      let yCoordinateMouse = coordinate[1];
      this.xPositionDragStart = xCoordinateMouse - leftDraggableElement;
      this.yPositionDragStart = yCoordinateMouse - topDraggableElement;
      this.elementIsGrabbed = true;
      this.elementIsOnTop = true;
    },
    progressDrag(e, stopDrag) {
      if (!this.elementIsGrabbed) return;
      this.removeSelection();
      let draggableElement = this.$refs[
        "draggable_" + this.recentElementDragged
      ];

      let coordinate = this.getCursorPosition(e);
      let xCoordinateMouse = coordinate[0];
      let yCoordinateMouse = coordinate[1] + window.pageYOffset;

      let translateX =
        xCoordinateMouse -
        this.xPositionDragStart -
        this.draggableElements[this.recentElementDragged].left;
      translateX = Math.max(
        translateX,
        -this.draggableElements[this.recentElementDragged].left
      );

      let translateY =
        yCoordinateMouse -
        this.yPositionDragStart -
        this.draggableElements[this.recentElementDragged].top;
      translateY = Math.max(
        translateY,
        -this.draggableElements[this.recentElementDragged].top + this.remToPx(6)
      );
      /* translateY = Math.min(
        translateY,
        this.$store.state.windowHeight -
          this.draggableElements[this.recentElementDragged].bottom -
          this.remToPx(6.75)
      ); */

      draggableElement.style.transform =
        "translate(" + translateX + "px," + translateY + "px)";

      this.organizeDropArea(translateX, translateY, stopDrag);
    },
    stopDrag() {},
    organizeDropArea(traX, traY, stopDrag) {
      this.removeSelection();
      let distanceBetweenBlocks = this.remToPx(1);

      let index;
      let draggableRecent;
      if (this.recentElementDragged !== -1) {
        index = this.recentElementDragged;
        draggableRecent = {
          top: this.draggableElements[index].top + traY,
          right: this.draggableElements[index].right + traX,
          bottom: this.draggableElements[index].bottom + traY,
          left: this.draggableElements[index].left + traX
        };
      } else {
        index = -1;
        draggableRecent = { top: 0, right: 0, bottom: 0, left: 0 };
      }

      let recentLine = -1;
      for (let i = 0; i < this.numberOfLines; i++) {
        if (
          draggableRecent.bottom >= this.droppableElements[i].top &&
          draggableRecent.top <= this.droppableElements[i].bottom &&
          draggableRecent.left <= this.droppableElements[i].right &&
          draggableRecent.right >= this.droppableElements[i].left
        ) {
          recentLine = i;
          break;
        }
      }
      this.recentLine = recentLine;
      // alert(0);
      if (
        this.answersInDropLines[0].indexOf(index) > -1 ||
        this.answersInDropLines[1].indexOf(index) > -1
      ) {
        for (let i = 0; i < this.answersInDropLines.length; i++) {
          let positionRecentInLine = this.answersInDropLines[i].indexOf(
            this.recentElementDragged
          );
          if (positionRecentInLine > -1) {
            this.answersInDropLines[i].splice(positionRecentInLine, 1);
          }
        }
        // this.testvar++;
        // return;
      }
      // alert(1);
      let answersInDropLines = JSON.parse(
        JSON.stringify(this.answersInDropLines)
      );

      if (this.recentLine > -1) {
        let positionRecentInLine = answersInDropLines[this.recentLine].indexOf(
          this.recentElementDragged
        );
        if (positionRecentInLine > -1) {
          this.answersInDropLines[this.recentLine].splice(
            positionRecentInLine,
            1
          );
        }

        let elementWasPutInBetween = false;
        for (let i = 0; i < answersInDropLines[this.recentLine].length; i++) {
          let widthElementsLeft = 0;
          for (let k = 0; k < i; k++) {
            widthElementsLeft +=
              this.draggableElements[answersInDropLines[this.recentLine][k]]
                .width + distanceBetweenBlocks; //////
          }
          if (
            draggableRecent.left <=
              widthElementsLeft +
                this.droppableElements[this.recentLine].left &&
            draggableRecent.right >=
              widthElementsLeft + this.droppableElements[this.recentLine].left
          ) {
            elementWasPutInBetween = true;

            answersInDropLines[this.recentLine].splice(
              i,
              0,
              this.recentElementDragged
            );
            if (stopDrag) {
              this.answersInDropLines[this.recentLine].splice(
                i,
                0,
                this.recentElementDragged
              );
            }
          }
        }

        if (!elementWasPutInBetween) {
          answersInDropLines[this.recentLine].push(this.recentElementDragged);

          if (stopDrag) {
            this.answersInDropLines = answersInDropLines;
          }
        }
      } else {
        for (let i = 0; i < this.answersInDropLines.length; i++) {
          let positionRecentInLine = this.answersInDropLines[i].indexOf(
            this.recentElementDragged
          );
          if (positionRecentInLine > -1) {
            this.answersInDropLines[i].splice(positionRecentInLine, 1);
          }
        }
      }

      // Rearrange elements in lines
      let answersInDropElement = [];
      for (let i = 0; i < this.numberOfLines; i++) {
        answersInDropElement = answersInDropElement.concat(
          answersInDropLines[i]
        );
      }
      answersInDropLines = [[], []];
      let widthOfElements = [];
      let duplicates = [];
      for (let i = 0; i < answersInDropElement.length; i++) {
        if (duplicates.indexOf(answersInDropElement[i]) === -1) {
          widthOfElements.push(
            this.draggableElements[answersInDropElement[i]].width
          );
        } else {
          widthOfElements.push(0);
        }

        duplicates.push(answersInDropElement[i]);
      }

      let breakingElement = 0;
      let breakingNumbers = [0];
      for (let i = 0; i < this.numberOfLines; i++) {
        let widthOfRecentLine = 0;
        for (let j = breakingElement; j < widthOfElements.length; j++) {
          widthOfRecentLine += widthOfElements[j] + distanceBetweenBlocks; ////
          if (
            widthOfRecentLine <=
            this.droppableElements[i].width + distanceBetweenBlocks
          ) {
            //////
            breakingElement = j;
          }
        }
        breakingNumbers[i + 1] = breakingElement + 1;
        if (i === this.numberOfLines - 1) {
          breakingNumbers[i + 1] = 10 * this.allAnswers.length;
        }
      }

      for (let j = 0; j < this.numberOfLines; j++) {
        answersInDropLines[j] = answersInDropElement.slice(
          breakingNumbers[j],
          breakingNumbers[j + 1]
        );
      }

      let croppedAnswersInDropLines = JSON.parse(
        JSON.stringify(answersInDropLines)
      );

      for (let i = 0; i < this.numberOfLines; i++) {
        let indexOfRecentElement = croppedAnswersInDropLines[i].indexOf(
          this.recentElementDragged
        );

        if (indexOfRecentElement > -1) {
          croppedAnswersInDropLines[i].splice(indexOfRecentElement, 1);
        }
      }

      this.answersInDropLines = croppedAnswersInDropLines;

      for (let i = 0; i < answersInDropLines.length; i++) {
        answersInDropLines[i] = [...new Set(answersInDropLines[i])];
      }

      if (stopDrag) {
        this.answersInDropLines = answersInDropLines;
      }

      for (let i = 0; i < answersInDropLines.length; i++) {
        for (let j = 0; j < answersInDropLines[i].length; j++) {
          let widthElementsLeftOfRecent = 0;
          for (let k = 0; k < j; k++) {
            widthElementsLeftOfRecent +=
              this.draggableElements[answersInDropLines[i][k]].width +
              distanceBetweenBlocks; //////
          }
          let translateX =
            widthElementsLeftOfRecent -
            this.draggableElements[answersInDropLines[i][j]].left +
            this.droppableElements[i].left;
          let translateY =
            this.droppableElements[i].top -
            this.draggableElements[answersInDropLines[i][j]].top;
          if (
            answersInDropLines[i][j] !== this.recentElementDragged ||
            stopDrag
          ) {
            this.$refs[
              "draggable_" + answersInDropLines[i][j]
            ].style.transform =
              "translate(" + translateX + "px, " + translateY + "px)";
          }
        }
      }

      if (this.recentLine === -1 && stopDrag) {
        this.answersInDropElement = answersInDropElement;
        this.$refs["draggable_" + this.recentElementDragged].style.transform =
          "none";

        this.$store.dispatch("setExerciseStatus", 1);
        this.$store.dispatch("addExerciseData", [
          "answersInDropElement",
          answersInDropElement
        ]);
        this.$store.dispatch("addExerciseData", [
          "answersInDropLines",
          answersInDropLines
        ]);
      }

      if (stopDrag) {
        this.elementIsGrabbed = false;
      }

      if (this.recentLine > -1 && stopDrag) {
        this.$store.dispatch("setExerciseStatus", 1);
        this.$store.dispatch("addExerciseData", [
          "answersInDropElement",
          answersInDropElement
        ]);
        this.$store.dispatch("addExerciseData", [
          "answersInDropLines",
          answersInDropLines
        ]);
        this.$store.dispatch("addExerciseData", [
          "evaluateButtonIsActive",
          true
        ]);
        this.answersInDropElement = answersInDropElement;
        this.evaluateButtonIsActive = true;
        this.playAudio("accept");

        /*  
      if (
        this.answersInDropElement.length === this.answers.length ||
        (this.allAnswers.length > this.answers.length &&
          this.answersInDropElement.length > 0)
      ) {
      } else {
        this.$store.dispatch("addExerciseData", [
          "evaluateButtonIsActive",
          false
        ]);
      } */
        // this.evaluateButtonIsActive = false;
        // this.droppableIsActive = true;
      }
    },
    sortAdditionalElements() {
      let topOfRecentElement = -10000;
      let rowBeginsAtIndexArray = [];
      for (let i = 0; i < this.allAnswers.length; i++) {
        if (this.answersInDropElement.indexOf(i) > -1) {
          continue;
        }

        let topRecent = this.draggableElements[i].top;
        if (topRecent > topOfRecentElement) {
          topOfRecentElement = topRecent;
          rowBeginsAtIndexArray.push(i);
        }
      }

      for (let i = 0; i < this.allAnswers.length; i++) {
        if (this.answersInDropElement.indexOf(i) > -1) {
          continue;
        }

        let elementIsInRow = 0;
        let widthPrevious = 0;
        for (let j = 0; j < rowBeginsAtIndexArray.length; j++) {
          if (
            j === rowBeginsAtIndexArray.length - 1 ||
            (i >= rowBeginsAtIndexArray[j] && i < rowBeginsAtIndexArray[j + 1])
          ) {
            elementIsInRow = j;
            break;
          }
        }

        let startIndex = this.allAnswers.length - 1;
        if (elementIsInRow < rowBeginsAtIndexArray.length - 1) {
          startIndex = rowBeginsAtIndexArray[elementIsInRow + 1] - 1;
        }
        for (let j = startIndex; j > i; j--) {
          if (this.answersInDropElement.indexOf(j) === -1) {
            widthPrevious += this.draggableElements[j].width + this.remToPx(1);
          }
        }

        let translateX =
          this.droppableElements[0].right -
          widthPrevious -
          this.draggableElements[i].right;
        if (this.$store.state.windowWidth > 600) {
          translateX += this.remToPx(3);
        }

        let distanceY = this.remToPx(4);
        if (this.$store.state.windowWidth <= 600) {
          distanceY = this.remToPx(1.5);
        }

        let translateY =
          this.droppableElements[this.droppableElements.length - 1].bottom -
          this.draggableElements[i].top +
          elementIsInRow *
            (this.draggableElements[0].height + this.remToPx(1.5)) +
          distanceY;

        let draggableElement = this.$refs["draggable_" + i];
        draggableElement.style.transform = "translateX(" + translateX + "px)";

        setTimeout(() => {
          draggableElement.style.transform =
            "translate(" + translateX + "px," + translateY + "px)";
        }, 600);
      }
    },
    removeSelection() {
      // probably remove
      window.getSelection().removeAllRanges();
      setTimeout(() => {
        window.getSelection().removeAllRanges();
      }, 405);
    },
    getAnswerArray(numberArray) {
      let answerArray = [];
      for (let i = 0; i < numberArray.length; i++) {
        answerArray[i] = this.allAnswers[numberArray[i]];
      }
      return answerArray;
    },
    evaluateAnswer() {
      if (!this.evaluateButtonIsActive) {
        return;
      }
      this.droppableIsActive = true;

      let copyCorrectAnswers = this.correctAnswers.slice(0);
      let reverseCorrectAnswers = copyCorrectAnswers.reverse();
      let permittedAnswerIsCorrect = false;
      let permittedAnswerNumber = -1;
      for (let i = 0; i < this.correctPermittedAnswers.length; i++) {
        let answerIsCorrect = true;
        for (let j = 0; j < this.answersInDropElement.length; j++) {
          if (
            this.answersInDropElement.length !==
            this.correctPermittedAnswers[i].length
          ) {
            answerIsCorrect = false;
            break;
          }
          let answerMatches = false;
          for (let k = 0; k < this.correctPermittedAnswers[i][j].length; k++) {
            if (
              this.allAnswers[this.answersInDropElement[j]] ===
              this.allAnswers[this.correctPermittedAnswers[i][j][k]]
            ) {
              answerMatches = true;
              break;
            }
          }
          if (!answerMatches) {
            answerIsCorrect = false;
          }
        }
        if (answerIsCorrect) {
          permittedAnswerIsCorrect = true;
          permittedAnswerNumber = i;
          break;
        }
      }

      if (
        permittedAnswerIsCorrect ||
        this.getAnswerArray(this.answersInDropElement) ==
          "" + this.getAnswerArray(this.correctAnswers) ||
        (this.allowReversedOrder &&
          this.getAnswerArray(this.answersInDropElement) ==
            "" + this.getAnswerArray(reverseCorrectAnswers))
      ) {
        this.$store.dispatch("setExerciseStatus", 4);
        this.$store.dispatch("addExerciseData", ["exerciseFinished", 2]);
        let delayAudio = 0;
        if (!this.playAnswerAudioOnly) {
          delayAudio = 500;
          // this.playAudio("completion");
          this.playAudio("correct");
        }

        setTimeout(() => {
          if (
            permittedAnswerNumber > -1 &&
            this.permittedAnswers[permittedAnswerNumber].audio
          ) {
            let audio = this.permittedAnswers[permittedAnswerNumber].audio;
            this.playAudio(audio);
          }
        }, delayAudio);
        this.answerIsCorrect = true;
        this.exerciseFinished = 1;
        // this.sortAdditionalElements();
        this.messageIsShown = false;
        let delay = 667;

        // let newMessageData = this.generateMessage(this.info);
        // this.executeFeedback(newMessageData);
        let delayMessage = 0;
        if (this.additionalAnswers && this.additionalAnswers.length > 0) {
          delayMessage = 667;
        }

        let info;
        if (
          permittedAnswerNumber > -1 &&
          this.permittedAnswers[permittedAnswerNumber].info !== undefined
        ) {
          info = this.permittedAnswers[permittedAnswerNumber].info;
        } else if (
          this.getAnswerArray(this.answersInDropElement) ==
            "" + this.getAnswerArray(this.correctAnswers) &&
          this.info !== undefined
        ) {
          info = this.info;
        } else if (
          this.allowReversedOrder &&
          this.getAnswerArray(this.answersInDropElement) ==
            "" + this.getAnswerArray(reverseCorrectAnswers) &&
          this.infoReversed !== undefined
        ) {
          info = this.infoReversed;
        } else if (this.infoGeneral !== undefined) {
          info = this.infoGeneral;
        }
        if (info !== "") {
          setTimeout(() => {
            let newMessageData = this.generateMessage(info);
            this.executeFeedback(newMessageData);
          }, delayMessage);
        }

        delay = 967;
        this.sortAdditionalElements();
        setTimeout(() => {
          this.answerIsCorrect = false;
          // this.exerciseFinished = 2;
          // this.sortAdditionalElements();
        }, delay);
        setTimeout(() => {
          this.exerciseFinished = 2;
        }, 1650);
      } else {
        this.$store.dispatch("setExerciseStatus", 2);

        this.evaluateButtonIsActive = false;
        if (this.autoEvaluate) return;
        this.playAudio("wrong");
        this.answerIsWrong = true;
        //// this.organizeDropArea();

        let answersReverted =
          this.getAnswerArray(this.answersInDropElement) ==
          "" + this.getAnswerArray(reverseCorrectAnswers);

        setTimeout(() => {
          this.answerIsWrong = false;
        }, 667);
        this.giveFeedback(answersReverted);
      }
    },
    giveFeedback(answersReverted) {
      let newMessageData;

      // let permittedAnswerIsCorrect = false;
      let adaptedWrongAnswerWasGiven = false;
      // let permittedAnswerNumber = -1;
      let wrongAnswerNumber = -1;
      for (let i = 0; i < this.wrongAdaptedAnswers.length; i++) {
        let answerIsCorrect = true;
        for (let j = 0; j < this.answersInDropElement.length; j++) {
          if (
            this.answersInDropElement.length !==
            this.wrongAdaptedAnswers[i].length
          ) {
            answerIsCorrect = false;
            break;
          }
          let answerMatches = false;
          for (let k = 0; k < this.wrongAdaptedAnswers[i][j].length; k++) {
            if (
              this.allAnswers[this.answersInDropElement[j]] ===
              this.allAnswers[this.wrongAdaptedAnswers[i][j][k]]
            ) {
              answerMatches = true;
              break;
            }
          }
          if (!answerMatches) {
            answerIsCorrect = false;
          }
        }
        if (answerIsCorrect) {
          adaptedWrongAnswerWasGiven = true;
          wrongAnswerNumber = i;
          break;
        }
      }

      if (adaptedWrongAnswerWasGiven) {
        newMessageData = this.generateMessage(
          this.feedbackAdaptedToAnswer[wrongAnswerNumber].feedback,
          "error"
        );
        this.executeFeedback(newMessageData);
        return;
      }

      if (answersReverted && this.feedbackReversedOrder) {
        newMessageData = this.generateMessage(
          this.feedbackReversedOrder,
          "error"
        );
        this.executeFeedback(newMessageData);
        return;
      }

      if (this.feedbackFailedTries) {
        if (this.numberOfFailedTries < this.feedbackFailedTries.length - 1) {
          newMessageData = this.generateMessage(
            this.feedbackFailedTries[this.numberOfFailedTries],
            "error"
          );
          this.executeFeedback(newMessageData);
          return;
        } else if (
          this.numberOfFailedTries === this.feedbackFailedTries.length - 1 &&
          this.feedbackFailedTries[this.numberOfFailedTries] !== true &&
          this.feedbackFailedTries[this.numberOfFailedTries] !== false
        ) {
          newMessageData = this.generateMessage(
            this.feedbackFailedTries[this.numberOfFailedTries],
            "error"
          );
          this.executeFeedback(newMessageData);
          this.messageIsShown = false;
          return;
        } else if (
          this.numberOfFailedTries === this.feedbackFailedTries.length - 1 &&
          this.feedbackFailedTries[this.numberOfFailedTries] === true
        ) {
          newMessageData = this.generateMessage(
            this.feedbackFailedTries[this.numberOfFailedTries - 1],
            "error"
          );
          this.executeFeedback(newMessageData);
          return;
        } else if (
          this.feedbackFailedTries[this.feedbackFailedTries.length - 1] === true
        ) {
          newMessageData = this.generateMessage(
            this.feedbackFailedTries[this.feedbackFailedTries.length - 2],
            "error"
          );
          this.executeFeedback(newMessageData);
          return;
        }
      }

      if (
        this.feedbackAdditionalWasUsed &&
        this.feedbackAdditionalWasUsed.length > 0
      ) {
        let additionalElementWasUsed = false;
        for (let i = 0; i < this.answersInDropElement.length; i++) {
          if (
            this.correctAnswers.indexOf(this.answersInDropElement[i]) === -1
          ) {
            additionalElementWasUsed = true;
            break;
          }
        }
        if (additionalElementWasUsed) {
          newMessageData = this.generateMessage(
            this.feedbackAdditionalWasUsed,
            "error"
          );
          this.executeFeedback(newMessageData);
          return;
        }
      }

      if (
        (this.feedbackElementLacking !== undefined &&
          typeof this.feedbackElementLacking === "object") ||
        (this.feedbackElementLacking !== undefined &&
          this.feedbackElementLacking.length > 0)
      ) {
        let elementIsLacking = false;
        for (let i = 0; i < this.answers.length; i++) {
          if (
            this.answersInDropElement.indexOf(this.correctAnswers[i]) === -1
          ) {
            elementIsLacking = true;
            break;
          }
        }
        if (elementIsLacking) {
          newMessageData = this.generateMessage(
            this.feedbackElementLacking,
            "error"
          );
          this.executeFeedback(newMessageData);
          return;
        }
      }

      if (this.feedbackGeneral) {
        newMessageData = this.generateMessage(this.feedbackGeneral, "error");
        this.executeFeedback(newMessageData);
        return;
      }
      this.messageIsShown = false;
    },
    executeFeedback(feedback) {
      if (
        this.compareObjects(feedback, this.messageData) &&
        this.messageIsShown
      )
        return;
      this.messageIsShown = false;
      setTimeout(() => {
        this.messageData = feedback;
        this.messageIsShown = true;
        this.numberOfFailedTries++;
      }, 725);
    },

    determineDistances() {
      // alert(1);
      for (let i = 0; i < this.allAnswers.length; i++) {
        this.draggableElements[i] = this.getCoordinates(
          this.$refs["draggable_" + i]
        );
        // this.draggableElements[i].top - document.documentElement.scrollTop;
      }

      for (let i = 0; i < this.numberOfLines; i++) {
        this.droppableElements[i] = this.getCoordinates(
          this.$refs["droppable__" + i]
        );
      }

      // Determine number of drop field lines
      // let widthCorrectAnswers = -this.remToPx(1.5);

      /* if (this.numberOfLines === 1) {
        for (let i = 0; i < this.answers.length; i++) {
          widthCorrectAnswers +=
            this.draggableElements[i][2] + this.remToPx(1.5);
        }
        if (
          widthCorrectAnswers >
          this.$store.state.windowWidth - this.remToPx(1.5)
        ) {
          this.numberOfLines = 2;
          if (
            widthCorrectAnswers >
            2 * this.$store.state.windowWidth - this.remToPx(1.5)
          ) {
            this.numberOfLines = 3;
          }
        }
      } */
    },
    organizeAfterResize() {
      this.$store.state.courseKey2++;
      this.typesetMath();
    },
    randomizeQuestions() {
      let randomizeArray = this.generateNumberArray(this.allAnswers.length);
      let randomize = this.content.randomize || randomizeArray;
      let newOrder = this.shuffle(randomize);
      let numberArray = this.generateNumberArray(this.allAnswers.length);

      for (let i = 0; i < randomize.length; i++) {
        numberArray[randomize[i]] = newOrder[i];
      }

      if (this.savedOrderOfAnswers.length > 0) {
        return this.savedOrderOfAnswers;
      } else {
        this.$store.dispatch("addExerciseData", [
          "savedOrderOfAnswers",
          numberArray
        ]);
        return numberArray;
      }
    },
    initializeExercise() {
      if (!this.additionalAnswers || this.additionalAnswers === undefined) {
        this.additionalAnswers = [];
      }
      this.allAnswers = [...this.answers, ...this.additionalAnswers];

      let auxArray = this.generateNumberArray(this.allAnswers.length);
      let orderIsValid = true;

      // Handle given order of answers
      if (
        this.orderOfAnswers &&
        Array.isArray(this.orderOfAnswers) &&
        this.orderOfAnswers.length > 0
      ) {
        let a = this.orderOfAnswers.slice(0),
          b = auxArray;
        let orderIsAdmissible =
          JSON.stringify(a.sort()) === JSON.stringify(b.sort());
        if (!orderIsAdmissible) {
          alert("!");
          this.orderOfAnswers = auxArray;
          orderIsValid = false;
          this.reRandomizeQuestions = true;
        }
      } else if (this.orderOfAnswers && !Array.isArray(this.orderOfAnswers)) {
        alert("!");
        this.orderOfAnswers = auxArray;
        orderIsValid = false;
        this.reRandomizeQuestions = true;
      } else {
        this.orderOfAnswers = auxArray;
        orderIsValid = false;
        this.reRandomizeQuestions = true;
      }

      // Randomize Questions
      if (!orderIsValid || this.reRandomizeQuestions) {
        this.orderOfAnswers = this.randomizeQuestions();
      }

      let answersInNewOrder = [];
      for (let i = 0; i < this.allAnswers.length; i++) {
        answersInNewOrder[i] = this.allAnswers[this.orderOfAnswers[i]];
      }
      this.allAnswers = answersInNewOrder;

      this.correctAnswers = this.invertArray(this.orderOfAnswers).slice(
        0,
        this.answers.length
      );

      if (this.permittedAnswers && this.permittedAnswers.length > 0) {
        this.correctPermittedAnswers = this.generateArray(
          this.permittedAnswers.length,
          []
        );

        for (let i = 0; i < this.permittedAnswers.length; i++) {
          let answer;
          if (
            !Array.isArray(this.permittedAnswers[i]) &&
            typeof this.permittedAnswers[i] === "object"
          ) {
            answer = this.permittedAnswers[i]["answer"];
          } else {
            answer = this.permittedAnswers[i];
          }
          for (let j = 0; j < answer.length; j++) {
            if (!Array.isArray(answer[j])) {
              answer[j] = [answer[j]];
            }
            this.correctPermittedAnswers[i][j] = [];
            for (let k = 0; k < answer[j].length; k++) {
              this.correctPermittedAnswers[i][j][
                k
              ] = this.orderOfAnswers.indexOf(answer[j][k]);
            }
          }
        }
      }

      if (
        this.feedbackAdaptedToAnswer &&
        this.feedbackAdaptedToAnswer.length > 0
      ) {
        this.wrongAdaptedAnswers = this.generateArray(
          this.feedbackAdaptedToAnswer.length,
          []
        );

        for (let i = 0; i < this.feedbackAdaptedToAnswer.length; i++) {
          let answer;
          if (
            !Array.isArray(this.feedbackAdaptedToAnswer[i]) &&
            typeof this.feedbackAdaptedToAnswer[i] === "object"
          ) {
            answer = this.feedbackAdaptedToAnswer[i]["answer"];
          } else {
            answer = this.feedbackAdaptedToAnswer[i];
          }
          for (let j = 0; j < answer.length; j++) {
            if (!Array.isArray(answer[j])) {
              answer[j] = [answer[j]];
            }
            this.wrongAdaptedAnswers[i][j] = [];
            for (let k = 0; k < answer[j].length; k++) {
              this.wrongAdaptedAnswers[i][j][k] = this.orderOfAnswers.indexOf(
                answer[j][k]
              );
            }
          }
        }
      }
    },
    resetExercise() {
      this.savedOrderOfAnswers = [];
      this.evaluateButtonIsActive = false;

      this.$store.dispatch("setExerciseStatus", 0);
      this.$store.dispatch("addExerciseData", ["exerciseFinished", false]);
      this.$store.dispatch("addExerciseData", ["answersInDropElement", []]);
      this.$store.dispatch("addExerciseData", ["answersInDropLines", [[], []]]);

      (this.allAnswers = []),
        (this.correctAnswers = []),
        (this.correctPermittedAnswers = []),
        // (this.numberOfLines = 2),
        (this.recentElementDragged = 0),
        (this.elementsAreReset = false),
        (this.transitionIsSuspended = true),
        (this.elementIsGrabbed = false),
        (this.elementIsOnTop = false),
        (this.xPositionDragStart = 0),
        (this.yPositionDragStart = 0),
        (this.topOfDraggedElement = 0),
        (this.heightOfDraggedElement = 0),
        // (this.draggableElements = []),
        // (this.droppableElements = []),
        (this.droppableIsActive = false),
        (this.audioHasNotPlayed = true),
        (this.answersInDropElement = []),
        (this.answersInDropLines = [[], []]),
        (this.leftOfDroppedElements = []),
        (this.topOfDroppedElements = []),
        (this.answerIsCorrect = false),
        (this.answerIsWrong = false),
        (this.exerciseFinished = false),
        (this.numberOfFailedTries = 0),
        (this.sortAdditionalElementsTimerX = 667),
        (this.sortAdditionalElementsTimerY = 1067),
        (this.message = ""),
        (this.type = "message"),
        (this.image = ""),
        (this.messageData = {}),
        (this.messageIsShown = false);

      /* if (this.$store.state.windowWidth > 600) {
        this.numberOfLines = 1;
      } */

      this.initializeExercise();

      // // // this.organizeAfterResize();

      setTimeout(() => {
        this.transitionIsSuspended = false;
      }, 550);

      for (let i = 0; i < this.allAnswers.length; i++) {
        let draggableElement = this.$refs["draggable_" + i];
        draggableElement.style.transform = "none";
      }

      setTimeout(() => {
        this.determineDistances();
      }, 0);
    },

    autoSolve(droppedElements) {
      // this.a(droppedElements);
      this.transitionIsSuspended = true;

      for (let i = 0; i < droppedElements.length; i++) {
        for (let j = 0; j < droppedElements[i].length; j++) {
          let original = this.$refs["draggable_" + droppedElements[i][j]];
          let clone = original.cloneNode(true);
          original.style.opacity = 0;

          let fragment = document.createDocumentFragment();
          fragment.appendChild(clone);
          document
            .querySelector(".drag-and-drop__droppable--" + i)
            .appendChild(fragment);
          clone.style.backgroundColor = "#333";

          setTimeout(() => {
            // this.transitionIsSuspended = true;
            this.recentElementDragged = droppedElements[i][j];
            this.$store.dispatch("setExerciseStatus", 1);
            this.answersInDropElement.push(this.recentElementDragged);
            this.answersInDropLines[i].push(this.recentElementDragged);

            // this.organizeDropArea(0, 0);
            // original.style.transform = "translate(-100px, 200px)";

            setTimeout(() => {
              /* let translateX =
                this.draggableElements[droppedElements[0][0]].left -
                this.droppableElements[0].left -
                10;
              let translateY =
                this.draggableElements[droppedElements[0][0]].top -
                this.droppableElements[0].top; */
              // alert(999);
              this.recentElementDragged = -1;
              this.organizeDropArea(0, 0, true);
            }, 15);

            setTimeout(() => {
              original.style.opacity = 1;
              clone.style.opacity = 0;
              setTimeout(() => {
                clone.style.display = "none";
              }, 20);
            }, 20);
          }, 310);
        }
      }

      this.exerciseFinished = this.o([
        this.$store.state.userDataLectures[this.$store.state.chosenLesson]
          .savedExerciseData[this.$store.state.coursePage],
        "exerciseFinished",
        false
      ]);

      setTimeout(() => {
        this.transitionIsSuspended = false;
      }, 1000);
    }
  },
  created() {
    if (this.$store.state.windowWidth <= 600) {
      // this.numberOfLines = 1;
      this.numberOfLines = this.content.numberOfPhoneLines || 1;
    }

    this.evaluateButtonIsActive = this.o([
      this.$store.state.userDataLectures[this.$store.state.chosenLesson]
        .savedExerciseData[this.$store.state.coursePage],
      "evaluateButtonIsActive",
      false
    ]);

    /* setTimeout(() => {
      this.exerciseFinished = this.o([
        this.$store.state.userDataLectures[this.$store.state.chosenLesson]
          .savedExerciseData[this.$store.state.coursePage],
        "exerciseFinished",
        false
      ]);
    }, 0); // was 967 */

    if (
      this.o([
        this.$store.state.userDataLectures[this.$store.state.chosenLesson]
          .savedExerciseData[this.$store.state.coursePage],
        "savedOrderOfAnswers",
        "length",
        0
      ]) > 0
    ) {
      this.savedOrderOfAnswers = this.o([
        this.$store.state.userDataLectures[this.$store.state.chosenLesson]
          .savedExerciseData[this.$store.state.coursePage],
        "savedOrderOfAnswers",
        []
      ]);
    }

    /* if (
      this.o([
        this.$store.state.userDataLectures[this.$store.state.chosenLesson]
          .savedExerciseData[this.$store.state.coursePage],
        "answersInDropElement",
        "length",
        0
      ]) > 0
    ) {
      let answersInDropElement = this.o([
        this.$store.state.userDataLectures[this.$store.state.chosenLesson]
          .savedExerciseData[this.$store.state.coursePage],
        "answersInDropElement",
        []
      ]);

      /* setTimeout(() => {
        this.autoSolve(answersInDropElement);
      }, 0); */

    if (
      this.o([
        this.$store.state.userDataLectures[this.$store.state.chosenLesson]
          .savedExerciseData[this.$store.state.coursePage],
        "answersInDropLines",
        "length",
        0
      ]) > 0
    ) {
      let answersInDropLines = this.o([
        this.$store.state.userDataLectures[this.$store.state.chosenLesson]
          .savedExerciseData[this.$store.state.coursePage],
        "answersInDropLines",
        []
      ]);

      setTimeout(() => {
        this.autoSolve(answersInDropLines);
      }, 0);
    }

    window.addEventListener("mousemove", $event => this.progressDrag($event));
    window.addEventListener("touchmove", $event => this.progressDrag($event));
    window.addEventListener("mouseup", $event =>
      this.progressDrag($event, true)
    );
    window.addEventListener("touchend", $event =>
      this.progressDrag($event, true)
    );

    this.answers = this.content.answers;
    this.additionalAnswers = this.content.additionalAnswers;
    this.orderOfAnswers = this.content.orderOfAnswers || [];
    if (
      this.orderOfAnswers.length === 0 &&
      this.content.randomizeAnswers === false
    ) {
      let totalNumberOfAnswers =
        this.answers.length + this.additionalAnswers.length;
      for (let i = 0; i < totalNumberOfAnswers; i++) {
        this.orderOfAnswers[i] = i;
      }
    }
    this.permittedAnswers = this.content.permittedAnswers || [];
    this.allowReversedOrder = this.content.allowReversedOrder;
    this.completeSentence = this.content.completeSentence || false;
    this.feedbackGeneral = this.content.feedbackGeneral;
    this.feedbackFailedTries = this.content.feedbackFailedTries;
    this.feedbackReversedOrder = this.content.feedbackReversedOrder;
    this.feedbackElementLacking = this.content.feedbackElementLacking;
    this.feedbackAdditionalWasUsed = this.content.feedbackAdditionalWasUsed;
    this.feedbackAdaptedToAnswer = this.content.feedbackAdaptedToAnswer || [];
    this.infoGeneral = this.content.infoGeneral;
    this.infoReversed = this.content.infoReversed;

    let vm = this;
    setTimeout(() => {
      this.determineDistances();
      let resizeTimer;

      ["resize", "scroll"].forEach(evt =>
        window.addEventListener(
          evt,
          function() {
            clearTimeout(resizeTimer);
            resizeTimer = setTimeout(function() {
              if (evt === "resize") {
                vm.organizeAfterResize();
              } else {
                // this.determineDistances();
              }
            }, 250);
          },
          false
        )
      );
    }, 0); // was: 300

    this.initializeExercise();
  },
  watch: {
    isShown(to) {
      if (to) {
        this.organizeAfterResize();
      }
    },
    exerciseIsReset(to) {
      if (to) {
        this.resetExercise();
      }
    },
    language() {
      this.organizeAfterResize();
    }
  }
};
</script>

<style lang="scss" scoped>
@import "sass/main.scss";

.drag-and-drop {
  position: absolute;
  top: 6rem;
  width: 100%;
  min-height: 200vh;
  // // // padding-top: max(11rem, min(13.75rem, 10vh));
  padding-top: 5.5rem;
  color: $color-white;
  // background-color: #131313;
  background-color: #101010;

  // overflow: hidden;

  @include grid-template-columns;
  grid-template-rows: repeat(6, min-content) 1fr 1fr;

  @include respond(phone) {
    padding-top: 4.6rem;
    background-color: $color-black;
  }

  &__heading {
    grid-column: 3 / 4;
    margin-bottom: 4.125rem;
    text-align: center;
    font-weight: 400;

    @include respond(tab-land) {
      margin-bottom: 3.78125rem;
      line-height: 1.2;
    }

    @include respond(phone) {
      grid-column: 1 / 6;
      margin-bottom: 3.6rem;
      text-align: center;
      font-size: 4rem;
    }
  }

  &__image {
    grid-column: 3 / 4;
    justify-self: center;

    // background-color: $color-black;
  }

  &__instructions {
    // width: min(80rem, 100vw - 2 * #{$side-margin});
    width: min(#{$width-center}, 100% - 1.5rem);
    grid-column: 3 / 4;
    margin-bottom: 8.25rem;
    text-align: center;
    font-size: 2.8rem;
    white-space: pre-line;

    @include respond(tab-land) {
      width: min(80rem, 100vw - 2 * #{$side-margin-land});
      margin-bottom: 4.125rem;
    }

    @include respond(phone) {
      width: 100%;
      grid-column: 1 / 6;
      text-align: center;
      // line-height: 1.4;
    }
  }

  &__drag-area {
    grid-column: 3 / 4;
    width: 100%;
    height: 0;
    margin-top: 5.5rem;

    margin-bottom: 12.75rem;
  }

  &__draggable {
    position: relative;
    float: left;
    z-index: 10;
    height: 5.5rem;
    padding: 0 2.75rem;
    margin-bottom: 1rem;
    border-radius: 100rem;
    font-size: 2.4rem;
    line-height: 5.4rem;
    background-color: $color-primary-dark;
    transition: transform 0.4s;
    will-change: transform;
    cursor: grab;

    &:not(:last-child) {
      margin-right: 1rem; // was: 1.5rem

      /* @include respond(phone) {
        margin-bottom: 1rem;
      } */
    }

    &.drag-and-drop__reset {
      opacity: 0 !important;
      transform: none !important;
    }

    &.drag-and-drop__suspend-transition {
      transition: none !important;
    }

    &.drag-and-drop__is-grabbed {
      z-index: 1000;
      background-color: $color-primary-dark !important;
      transition: none;
      cursor: grabbing;
    }

    &.drag-and-drop__is-on-top {
      z-index: 1000;
    }

    &.drag-and-drop__is-dropped {
      background-color: #333;

      @include respond(phone) {
        background-color: #3a3a3a;
      }
    }

    &.drag-and-drop__is-dropped-finished {
      cursor: initial;
    }
  }

  &__correct {
    background-color: green !important;
    cursor: initial;
  }

  &__wrong {
    left: -2.75rem;
    background-color: transparent !important;

    & div {
      width: calc(100% + 5.5rem);
      height: 5.5rem;
      border-radius: 100rem;
      background-color: $color-wrong;
      text-align: center;
      color: $color-black;
      animation: shake 0.667s ease-in-out;
    }
  }

  &__inactive {
    background-color: #202020 !important;
    cursor: initial;
    transition: transform 0.4s, background-color 0.4s;

    @include respond(tab-land) {
      background-color: #151515 !important;
    }
  }

  &__capitalized {
    text-transform: capitalize;
  }

  &__period {
    display: inline-block;
    visibility: hidden;
    width: 0;

    &--visible {
      visibility: visible;
    }
  }

  &__drop-area {
    position: relative;
    grid-column: 3/ 4;
    height: 11rem;
    margin-top: 0;
    border-radius: 1rem;
    background-color: #000;
    // background-color: #080808;
    user-select: none;

    transition: background-color 0.2s;

    &:nth-child(3) {
      margin-top: 3rem;
    }

    @include respond(phone) {
      height: 7rem;
      border-radius: 0.6rem;
      background-color: $color-black;
    }

    &--active {
      // background-color: #222;

      @include respond(phone) {
        background-color: $color-black;
      }
    }
  }

  &__droppable {
    transform: translate(2.75rem, 2.75rem);
    width: calc(100% - 6rem);
    height: 5.5rem;
    border-radius: 100rem;
    background-color: #222;

    @include respond(phone) {
      transform: translateY(0.75rem);
      width: 100%;
    }

    &--active {
      // background-color: #1a1a1a;
    }
  }

  &__evaluate-button {
    // grid-row: 4 / 5;
    grid-column: 3 / 4;
    justify-self: end;
    margin-top: 4.125rem;

    @include respond(phone) {
      position: fixed;
      display: block;
      visibility: hidden;
      margin-top: 0;
      left: 0;
      top: 0;
      transform: translateY(calc(var(--vh, 1vh) * 100 - 6.5rem + 1px));
      width: 100vw;
      height: 6rem;
      font-size: 2.8rem;
      text-align: center;
      will-change: transform;
      transition: transform 0.75s, visibility 0s 0.75s;
    }

    &--is-active {
      visibility: visible;

      @include respond(phone) {
        transform: translateY(calc(var(--vh, 1vh) * 100 - 13.5rem + 1px));
        transition: transform 0.75s;
      }
    }

    &--is-greyed-out {
      background-color: $color-grey !important;
    }

    &--no-transition {
      transition: none !important;
    }
  }

  &__message {
    position: fixed;
    left: calc(50vw - 0.5 * min(#{$width-center}, (100vw - 6rem)));
    top: 0;
    z-index: 10;
    transform: translateY(calc(var(--vh, 1vh) * 100));
    width: min(#{$width-center}, (100vw - 6rem));
    max-height: max-content;

    &--is-shown {
      transform: translateY(calc(var(--vh, 1vh) * 100 - 100% - 13.5rem));
    }

    @include respond(phone) {
      position: fixed;
      left: 0;
      width: 100vw;

      &--is-shown {
        transform: translateY(calc(var(--vh, 1vh) * 100 - 100% - 13.9rem));

        &.drag-and-drop__message--evaluate-button-not-active {
          transform: translateY(calc(var(--vh, 1vh) * 100 - 100% - 6.75rem));
        }
      }
    }
  }

  &__continue-button {
    grid-row: 4 / 5;
    grid-column: 3 / 4;
    justify-self: end;
    padding: 0.85rem 2.4rem !important;
    margin-top: 10.125rem;
    margin-bottom: -6rem;

    visibility: hidden !important;
    background-color: $color-primary-dark;
    position: fixed;
    display: block;
    margin-top: 0;
    margin-bottom: 0;
    left: calc(50vw + 0.5 * min(#{$width-center}, 100vw - 6rem));
    top: 0;
    transform: translate(-100%, calc(var(--vh, 1vh) * 100 - 12rem));
    border-radius: 0.6rem;
    font-size: 2.3rem;
    text-align: center;
    will-change: transform;
    transition: transform 0.75s;

    @include respond(phone) {
      position: fixed;
      display: block;
      margin-top: 0;
      margin-bottom: 0;
      left: 0;
      top: 0;
      transform: translateY(calc(var(--vh, 1vh) * 100 - 6.5rem + 1px));
      width: 100vw;
      height: 6rem;
      font-size: 2.8rem;
      text-align: center;
      will-change: transform;
      transition: transform 0.75s;
    }

    &--shown {
      z-index: 1000000000;
      /* transform: translate3d(
        -100%,
        calc(var(--vh, 1vh) * 100 - 12.2rem + 1px),
        1000px
      ); */
      visibility: visible !important;
      transform-style: preserve-3d;

      @include respond(phone) {
        transform: translateY(calc(var(--vh, 1vh) * 100 - 13.5rem + 1px));
      }
    }
  }
}

@keyframes shake {
  0% {
    transform: translate(1px, 1px);
  }
  10% {
    transform: translate(-1px, -2px);
  }
  20% {
    transform: translate(-3px, 0px);
  }
  30% {
    transform: translate(3px, 2px);
  }
  40% {
    transform: translate(1px, -1px);
  }
  50% {
    transform: translate(-1px, 2px);
  }
  60% {
    transform: translate(-3px, 1px);
  }
  70% {
    transform: translate(3px, 1px);
  }
  80% {
    transform: translate(-1px, -1px);
  }
  90% {
    transform: translate(1px, 2px);
  }
  100% {
    transform: translate(1px, -2px);
  }
}

@keyframes shakeCorrect {
  0% {
    transform: none;
  }
  50% {
    transform: translateY(-4px);
  }
  100% {
    transform: none;
  }
}
</style>
